export type Theme = "dark" | "light";
export const themeStorageKey = "winterr-theme";
export const applyTheme = (theme: Theme) => {
  document.documentElement.dataset.theme = theme;
  document.documentElement.classList.toggle("dark", theme === "dark");
  try { localStorage.setItem(themeStorageKey, theme); } catch { /* Theme still works without storage. */ }
};
